<div class="container-fluid" *ngIf="(passwordValidationMessage | async) as validations">
    <div class="row top10 no-gutters">
        <div class="col-xs-12 col-md-6 vcenter">
            <h4>AIMS Password Reset</h4>
        </div>
        <div class="col-xs-12 col-md-6  vcenter-right">
            <aims-common-button (click)="resetMyPassword()" [disabled]="!formGroup.valid">
                Reset Password
            </aims-common-button>
        </div>
    </div>
    <hr />
    <aims-form cols='1'>
        <aims-fc >
            <mat-form-field>
                <input 
                    #aimsControl="ngModel"
                    matInput
                    required
                    [type]="hideOldPassword ? 'password' : 'text'"
                    [(ngModel)]="oldPassword" 
                    (ngModelChange)="onOldPasswordChange($event)"
                    name="Old Password" 
                    />
                <button id="hidePasswordBtn" mat-icon-button matSuffix (click)="hideOldPassword = !hideOldPassword"
                    [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hideOldPassword" tabindex="-1">
                    <mat-icon>{{hideOldPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                </button>
            </mat-form-field>
        </aims-fc >
        <aims-fc>
            <mat-form-field [class.mat-error]="!formGroup.controls.password.valid">
                <input 
                    #aimsControl="ngModel"
                    matInput
                    required
                    [type]="hidePassword ? 'password' : 'text'"
                    [(ngModel)]="password" 
                    name="New Password" 
                    (ngModelChange)="onPasswordChange($event)"
                    required/>
                <button id="hidePasswordBtn" mat-icon-button matSuffix (click)="hidePassword = !hidePassword"
                    [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassword" tabindex="-1">
                    <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                </button>
                <mat-hint>
                    <div *ngFor="let validation of validations.password" >
                        <div
                            *ngIf="formGroup.controls.password.hasError(validation.type)">
                            {{validation.message}}
                        </div>
                    </div>
                </mat-hint>
            </mat-form-field>
        </aims-fc>
        <aims-fc>
            <mat-form-field [class.mat-error]="!formGroup.controls.confirmPassword.valid">
                <input 
                    #aimsControl="ngModel"
                    matInput
                    required
                    [type]="hideConfirmPassword ? 'password' : 'text'"
                    [(ngModel)]="confirmPassword" 
                    name="Confirm Password" 
                    (ngModelChange)="onConfirmPasswordChange($event)"
                    />
                <button id="hidePasswordBtn" mat-icon-button matSuffix (click)="hideConfirmPassword = !hideConfirmPassword"
                    [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hideConfirmPassword" tabindex="-1">
                    <mat-icon>{{hideConfirmPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                </button>
                <mat-hint>
                    <div *ngFor="let validation of validations.confirmPassword" >
                        <div
                            *ngIf="formGroup.controls.confirmPassword.hasError(validation.type)">
                            {{validation.message}}
                        </div>
                    </div>
                </mat-hint>
            </mat-form-field>
        </aims-fc>
    </aims-form>

</div>
<aims-spinner [spinnerText]="spinnerText" [showSpinner]="showSpinner"></aims-spinner>